(function () {
  if (window.__teaQuizHubRedirectInlineV1) {
    window.__teaQuizRedirectGuard = 15;
    return;
  }

  if ((window.__teaQuizRedirectGuard || 0) >= 15) return;
  window.__teaQuizRedirectGuard = 15;

  window.__teaQuizRecoLoaded = true;
  window.__teaQuizRecoVersionLoaded = 20;

  var HUB_VIEW = 'quiz-results';
  var STORAGE_KEY = 'teaQuizConstitutionResults';
  var LOCK_KEY = 'teaQuizHubRedirectLock';
  var SCORE_THRESHOLD = 9;
  var NAMES = ['気虚', '血虚', '気滞', '陰虚', '陽虚', '痰湿', '瘀血', '平和'];

  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function isOnHubResultsPage() {
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var root = getRoot().replace(/\/$/, '') || '/';
    if (path === '/pages/quiz-results' || path === root + '/pages/quiz-results') return true;
    try {
      return new URLSearchParams(window.location.search).get('view') === HUB_VIEW;
    } catch (error) {
      return window.location.search.indexOf('view=' + HUB_VIEW) !== -1;
    }
  }

  function hubRedirectLocked() {
    if (window.__teaQuizHubRedirectLock) return true;
    try {
      var raw = sessionStorage.getItem(LOCK_KEY);
      if (!raw) return false;
      return Date.now() - Number(raw) < 120000;
    } catch (error) {
      return false;
    }
  }

  function setHubRedirectLock() {
    window.__teaQuizHubRedirectLock = 1;
    try {
      sessionStorage.setItem(LOCK_KEY, String(Date.now()));
    } catch (error) {}
  }

  function clearHubRedirectLock() {
    window.__teaQuizHubRedirectLock = 0;
    try {
      sessionStorage.removeItem(LOCK_KEY);
    } catch (error) {}
  }

  window.__teaQuizIsOnHubResultsPage = isOnHubResultsPage;

  function shouldBlockGuard() {
    if (isOnHubResultsPage()) return true;
    if (hubRedirectLocked()) return true;
    try {
      if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
      if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
    } catch (error) {}
    return false;
  }

  function clearRedirectOverlay() {
    document.documentElement.classList.remove('tea-quiz-redirect-pending');
    if (document.body) document.body.classList.remove('tea-quiz-redirect-pending');
    document.querySelectorAll('#shadow-quiz').forEach(function (host) {
      host.style.removeProperty('visibility');
      host.style.removeProperty('opacity');
      if (!host.shadowRoot) return;
      var style = host.shadowRoot.querySelector('#tea-quiz-redirect-hide-style');
      if (style) style.remove();
    });
    var overlay = document.getElementById('tea-quiz-redirect-overlay');
    if (overlay) overlay.remove();
  }

  function showRedirectOverlay() {
    return false;
  }

  function readScores() {
    if (window.Quiz && window.Quiz.variableScores) return window.Quiz.variableScores;
    if (window.quiz && window.quiz.variableScores) return window.quiz.variableScores;
    if (window.quiz && window.quiz.variables && window.quiz.variables.scores) {
      return window.quiz.variables.scores;
    }
    try {
      var raw = sessionStorage.getItem('teaQuizRawScores');
      if (raw) return JSON.parse(raw);
    } catch (error) {}
    return null;
  }

  function buildQualified(scores) {
    var list = [];
    NAMES.forEach(function (name) {
      var score = Number(scores && scores[name] ? scores[name] : 0);
      if (score >= SCORE_THRESHOLD) list.push({ name: name, score: score, percent: 0 });
    });
    if (!list.length) return null;
    list.sort(function (a, b) {
      return b.score - a.score;
    });
    if (list.length === 1) {
      list[0].percent = 100;
      return list;
    }
    var total = 0;
    list.forEach(function (item) {
      total += item.score;
    });
    var assigned = 0;
    list.forEach(function (item, index) {
      if (index === list.length - 1) {
        item.percent = Math.max(0, 100 - assigned);
        return;
      }
      item.percent = total > 0 ? Math.round((item.score / total) * 100) : 0;
      assigned += item.percent;
    });
    return list;
  }

  function shouldSkipHubRedirect() {
    if (isOnHubResultsPage()) return true;
    if (hubRedirectLocked()) return true;
    try {
      if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
      if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
    } catch (error) {}
    return false;
  }

  function redirectToHub() {
    if (shouldSkipHubRedirect()) return false;

    try {
      sessionStorage.removeItem('teaQuizBlockRedirect');
      sessionStorage.removeItem('teaQuizExplicitRetake');
    } catch (error) {}

    var scores = readScores();
    var qualified = buildQualified(scores);
    if (!qualified || !qualified.length) return false;

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ qualified: qualified, savedAt: Date.now() }));
      if (scores) sessionStorage.setItem('teaQuizRawScores', JSON.stringify(scores));
    } catch (error) {}

    setHubRedirectLock();
    window.location.replace(getRoot() + '?from=quiz&view=' + HUB_VIEW);
    return true;
  }

  var pollTimer = null;
  var pollAttempts = 0;

  function cancelRedirectPoll() {
    window.clearTimeout(pollTimer);
    pollTimer = null;
    pollAttempts = 0;
  }

  function pollRedirectToHub() {
    if (shouldSkipHubRedirect()) {
      cancelRedirectPoll();
      return;
    }
    if (redirectToHub()) {
      cancelRedirectPoll();
      return;
    }
    pollAttempts += 1;
    if (pollAttempts >= 25) {
      cancelRedirectPoll();
      return;
    }
    pollTimer = window.setTimeout(pollRedirectToHub, 200);
  }

  window.__teaQuizTryRedirectToResultsHub = redirectToHub;
  window.__teaQuizClearHubRedirectLock = clearHubRedirectLock;
  window.__teaQuizHubInlineV3 = 1;
  window.__teaQuizShowRedirectOverlay = showRedirectOverlay;
  window.__teaQuizClearRedirectOverlay = clearRedirectOverlay;

  if (isOnHubResultsPage()) {
    setHubRedirectLock();
    clearRedirectOverlay();
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildDetailUrl(name) {
    return getRoot() + 'collections/' + encodeURIComponent(name) + '?from=quiz&view=detail#constitution-info';
  }

  function readPersistedResults() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.qualified) || !parsed.qualified.length) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function renderHubResults(root) {
    if (!root || root.dataset.rendered === 'true') return;

    var data = readPersistedResults();
    if (!data) {
      root.innerHTML =
        '<div class="quiz-constitution-results__empty page-width">' +
          '<p class="quiz-constitution-results__empty-text">体質チェックの結果を読み込んでいます…</p>' +
          '<p class="quiz-constitution-results__empty-text quiz-constitution-results__empty-text--sub">' +
            '表示されない場合は、もう一度体質チェックをお試しください。' +
          '</p>' +
          '<p><a class="button button--primary" href="' + escapeHtml(getRoot() + '#quiz') + '">体質チェックをはじめる</a></p>' +
        '</div>';
      root.dataset.rendered = 'pending';
      return;
    }

    var cards = data.qualified
      .map(function (item) {
        var percent = typeof item.percent === 'number' ? item.percent : 0;
        return (
          '<a class="quiz-constitution-results__card" href="' + escapeHtml(buildDetailUrl(item.name)) + '">' +
            '<span class="quiz-constitution-results__card-name">' + escapeHtml(item.name) + '</span>' +
            '<span class="quiz-constitution-results__card-percent">' + escapeHtml(String(percent)) +
              '<span class="quiz-constitution-results__card-percent-sign">%</span></span>' +
            '<span class="quiz-constitution-results__card-action">くわしく見る</span>' +
          '</a>'
        );
      })
      .join('');

    root.innerHTML =
      '<div class="quiz-constitution-results__inner page-width">' +
        '<header class="quiz-constitution-results__header">' +
          '<p class="quiz-constitution-results__eyebrow">体質チェックの結果</p>' +
          '<h1 class="quiz-constitution-results__title">あなたに当てはまる体質</h1>' +
          '<p class="quiz-constitution-results__lead">回答内容から、9点以上となった体質を表示しています。気になる体質をタップして、説明とおすすめのお茶をご覧ください。</p>' +
        '</header>' +
        '<div class="quiz-constitution-results__grid">' + cards + '</div>' +
        '<p class="quiz-constitution-results__note">※ パーセントは、該当した体質のスコア合計に対する割合です。</p>' +
      '</div>';
    root.dataset.rendered = 'true';
  }

  function mountHubResultsPage() {
    if (!isOnHubResultsPage()) return;

    document.documentElement.classList.add('quiz-results-from-quiz');
    clearRedirectOverlay();

    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.mountHubPage) {
      window.TeaQuizConstitutionHub.mountHubPage();
    }

    var root = document.querySelector('[data-quiz-constitution-results]');
    if (root && root.dataset.rendered === 'pending' && readPersistedResults()) {
      root.dataset.rendered = '';
    }
    renderHubResults(root);
  }

  function retryMountHubResultsPage() {
    if (!isOnHubResultsPage()) return;
    var root = document.querySelector('[data-quiz-constitution-results]');
    if (root && root.dataset.rendered === 'true') return;
    mountHubResultsPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountHubResultsPage);
  } else {
    mountHubResultsPage();
  }

  window.setTimeout(retryMountHubResultsPage, 300);
  window.setTimeout(retryMountHubResultsPage, 1200);
  window.addEventListener('pageshow', mountHubResultsPage);

  function resetQuizSession() {
    window.__teaQuizAllowResultRedirect = false;
    window.__teaQuizQuizSessionActive = false;
    clearRedirectOverlay();
  }

  function clearRedirectGuard() {
    resetQuizSession();
  }

  function markFreshQuizCompletion() {
    if (shouldBlockGuard()) return;
    window.__teaQuizAllowResultRedirect = true;
  }

  function markQuizQuestionSeen() {
    window.__teaQuizQuizSessionActive = true;
  }

  function hasActiveQuizSession() {
    return window.__teaQuizQuizSessionActive === true || window.__teaQuizAllowResultRedirect === true;
  }

  window.__teaQuizClearRedirectGuard = clearRedirectGuard;
  window.__teaQuizResetQuizSession = resetQuizSession;
  window.__teaQuizMarkFreshQuizCompletion = markFreshQuizCompletion;
  window.__teaQuizMarkQuizQuestionSeen = markQuizQuestionSeen;
  window.__teaQuizHasActiveQuizSession = hasActiveQuizSession;
  window.__teaQuizInjectShadowHideStyle = function () {};

  window.addEventListener(
    'message',
    function (event) {
      var data = event.data;
      if (!data || data.channel !== 'revenuehunt:quiz-renderer') return;

      if (data.type === 'isQuestion') {
        markQuizQuestionSeen();
        clearHubRedirectLock();
        clearRedirectOverlay();
        return;
      }

      if (data.type !== 'isResult') return;
      if (shouldSkipHubRedirect()) {
        clearRedirectOverlay();
        return;
      }

      pollAttempts = 0;
      cancelRedirectPoll();
      pollRedirectToHub();
    },
    true
  );
})();
